var _path, _path2, _path3, _circle, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginToConsole(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 50,
    viewBox: "0 0 52 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5527 20.4574V19.2522C20.5527 18.8365 20.81 18.4641 21.1988 18.3169L28.1322 15.6933C28.3603 15.607 28.612 15.607 28.8401 15.6933L35.8102 18.331C36.1803 18.4711 36.4338 18.8169 36.452 19.2122C36.7886 26.5258 35.8216 31.4897 28.617 34.3886C28.5329 34.4224 28.4391 34.4341 28.351 34.413C26.9833 34.0848 23.6659 31.9859 22.2471 29.5426",
    stroke: "#141414",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4912 24.5378C15.077 24.5378 14.7412 24.8736 14.7412 25.2878C14.7412 25.7021 15.077 26.0378 15.4912 26.0378V24.5378ZM15.4912 26.0378H22.6674V24.5378H15.4912V26.0378Z",
    fill: "#141414"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.553 23.0273L22.4956 24.9378C22.6937 25.1326 22.695 25.4515 22.4986 25.6479L20.5527 27.5937",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.531,
    cy: 23.2732,
    r: 1.78101,
    fill: "#141414"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1104 27.3236V28.4982C25.1104 28.5037 25.1148 28.5082 25.1204 28.5082H31.942C31.9475 28.5082 31.952 28.5037 31.952 28.4982V27.3278C31.952 27.1467 31.8707 26.9735 31.7249 26.8659C29.1911 24.9961 26.5553 25.9898 25.3336 26.8695C25.1885 26.9739 25.1104 27.1449 25.1104 27.3236Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginToConsole);
export default __webpack_public_path__ + "static/media/login_to_console.34e9f39b67e03ae7bce24e55cc6d2c7d.svg";
export { ForwardRef as ReactComponent };